import WhatsappIcon from './icons/WhatsappIcon';
import WhatsappFull from '../assets/images/share/whatsapp_full.png';
import FullImageShare from './ui/FullImageShare';
export default function WhatsappShareButton({ validated, sharePostTitle, onSendEvent, fullIcon = false, certificate }) {
    return (
        <>
            {validated && (
                <a
                    href={`https://api.whatsapp.com/send?text=${certificate.url}%0A${sharePostTitle}`}
                    data-action="share/whatsapp/share"
                    onClick={() => onSendEvent('whatsapp')}
                    target="_blank"
                >
                    {fullIcon && <FullImageShare img={WhatsappFull} />}
                    {!fullIcon && <WhatsappIcon />}
                </a>
            )}
            {!validated && <WhatsappIcon fill={'#F6F6F6'} icon={'#CCC9D1'} />}
        </>
    );
}
